import { useMemo } from 'react';
import { BackSection } from 'src/components/common/BackSection';
import { EventHeaderNavTabs } from 'src/components/Events/EventHeader/EventHeaderNavTabs';
import { EventHeaderWithActions } from 'src/components/Events/EventHeader/EventHeaderWithActions';
import { TabItem } from 'src/components/Events/EventPage/EventPageTabs';
import { vars } from 'src/core/themes';
import { Stack } from 'src/core/ui';
import { useGetEventFullInfo } from 'src/hooks/useGetEventFullInfo';
import { useMatchMedia } from 'src/hooks/useMatchMedia';
import { Event } from 'src/WebApiController';

import { SaleEventTabs } from '../SaleEventPage';
import { SalesEventPageHeaderWithNav } from './SalesEventPageHeaderWithNav';

export const SalesEventPageHeaderV2 = ({
  event,
  tabs,
  activeTab,
  setActiveTab,
  returnUrl,
  defaultTab,
  onUpdateDefaultTab,
}: {
  event: Event;
  returnUrl?: string;
  activeTab: SaleEventTabs;
  setActiveTab: (tab: SaleEventTabs) => void;
  tabs: TabItem<SaleEventTabs>[];
  defaultTab?: SaleEventTabs;
  onUpdateDefaultTab: (tab: SaleEventTabs) => void;
}) => {
  const { venue, performer } = useGetEventFullInfo(event);
  const isMobile = useMatchMedia('mobile');

  const selectedTab = useMemo(() => {
    const sanitzedTab =
      activeTab === SaleEventTabs.None ? SaleEventTabs.Sales : activeTab;
    return tabs.find((tab) => tab.value === sanitzedTab);
  }, [activeTab, tabs]);

  return (
    <>
      <Stack
        gap={isMobile ? 's' : 'm'}
        direction="column"
        style={{ padding: `0 ${vars.spacing.sm}` }}
      >
        {isMobile && (
          <Stack alignItems="center" width="full">
            <BackSection
              returnUrl={returnUrl ?? '/sales'}
              returnState={{
                fromViagVirtId: event.virtId,
              }}
              iconOnly
            />
            <div style={{ flex: '1 1 auto', minWidth: 0 }}>
              <EventHeaderNavTabs<SaleEventTabs>
                defaultTab={defaultTab}
                activeTab={activeTab}
                setActiveTab={setActiveTab}
                onUpdateDefaultTab={onUpdateDefaultTab}
                tabs={tabs.map((tab) => ({
                  value: tab.value,
                  contentId: tab.contentId!,
                }))}
              />
            </div>
          </Stack>
        )}
        <EventHeaderWithActions
          event={event}
          performer={performer}
          venue={venue}
        />
        <SalesEventPageHeaderWithNav
          event={event}
          venue={venue}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          tabs={tabs}
        />
      </Stack>
      <div
        className={selectedTab?.className}
        style={{ width: '100%', paddingTop: vars.spacing.xs }}
      >
        {selectedTab?.content}
      </div>
    </>
  );
};
